module.exports = __webpack_public_path__ + "img/image_2.cd4a43c9.png";